import { render, staticRenderFns } from "./ClientBackground.vue?vue&type=template&id=6ccc2667&scoped=true&"
import script from "./ClientBackground.vue?vue&type=script&lang=js&"
export * from "./ClientBackground.vue?vue&type=script&lang=js&"
import style0 from "../../css/newProjectDetail.css?vue&type=style&index=0&id=6ccc2667&scoped=true&lang=css&"
import style1 from "./ClientBackground.vue?vue&type=style&index=1&id=6ccc2667&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccc2667",
  null
  
)

export default component.exports